import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import ProductCard from "@/components/ProductCard";
import { Heart } from "lucide-react";

export default function Wishlist() {
  const { wishlist } = useCart();
  const { user } = useAuth();

  if (!user) return (
    <div className="max-w-3xl mx-auto p-14 text-center">
      <Heart className="w-12 h-12 text-slate-400 mx-auto mb-4" />
      <h2 className="font-heading text-2xl font-semibold">Please sign in to view your wishlist</h2>
      <Link to="/login" className="mt-6 inline-block bg-blue-900 hover:bg-blue-800 text-white px-6 py-3 rounded-xl">Sign in</Link>
    </div>
  );

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
      <h1 className="font-heading text-3xl sm:text-4xl font-bold text-slate-950 mb-8">Your Wishlist</h1>
      {wishlist.length === 0 ? (
        <div className="text-center py-20 border border-slate-200 rounded-2xl">
          <Heart className="w-10 h-10 text-slate-400 mx-auto mb-4" />
          <p className="text-slate-600 mb-6">Your wishlist is empty</p>
          <Link to="/products" className="bg-blue-900 hover:bg-blue-800 text-white px-6 py-3 rounded-xl">Browse products</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {wishlist.map((p) => <ProductCard key={p.product_id} product={p} />)}
        </div>
      )}
    </div>
  );
}
